var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Text, Line } from '@react-three/drei';
import { BufferGeometry, BufferAttribute, Vector3, Euler } from 'three';
import { LiftState as RmfLiftState } from 'rmf-models';
import { getLiftModeText } from '../lift-marker';
var LiftShapeMaker = function (_a) {
    var motionState = _a.motionState;
    var vertices = new Float32Array([0, 1, 0, -0.5, -0.5, 0, 0.5, -0.5, 0]);
    var generateTriangleShape = function (rotation) {
        var geometry = new BufferGeometry();
        geometry.setAttribute('position', new BufferAttribute(vertices, 3));
        return (React.createElement("mesh", { geometry: geometry, rotation: rotation },
            React.createElement("meshBasicMaterial", { color: "red" })));
    };
    var generateLineShape = function () {
        var points = [
            [-0.5, 0.5, 0],
            [0.5, 0.5, 0],
            [0.5, -0.5, 0],
            [-0.5, -0.5, 0],
            [-0.5, 0.5, 0],
        ].map(function (point) { return new (Vector3.bind.apply(Vector3, __spreadArray([void 0], point, false)))(); });
        return React.createElement(Line, { points: points, color: "black", linewidth: 1 });
    };
    var generateTextShape = function () {
        return (React.createElement(Text, { color: "black", fontSize: 0.6 },
            ' ',
            '?'));
    };
    var shapeComponent;
    switch (motionState) {
        case RmfLiftState.MOTION_UP:
            shapeComponent = generateTriangleShape(new Euler(0, 0, 0));
            break;
        case RmfLiftState.MOTION_DOWN:
            shapeComponent = generateTriangleShape(new Euler(0, 0, Math.PI));
            break;
        case RmfLiftState.MOTION_STOPPED:
            shapeComponent = generateLineShape();
            break;
        default:
            shapeComponent = generateTextShape();
            break;
    }
    return shapeComponent;
};
export var LiftThreeMaker = function (_a) {
    var x = _a.x, y = _a.y, yaw = _a.yaw, width = _a.width, depth = _a.depth, liftState = _a.liftState;
    return (React.createElement("group", { position: [x, y, yaw] },
        React.createElement(Text, { color: "black", fontSize: 0.6 }, liftState.current_floor),
        React.createElement(Text, { position: [0, 0.8, 0.5], color: "black", fontSize: 0.6 }, getLiftModeText(liftState)),
        React.createElement(LiftShapeMaker, { motionState: liftState.motion_state }),
        React.createElement("mesh", { position: [0, 0, 0], rotation: [0, 0, yaw] },
            React.createElement("boxGeometry", { args: [width, depth, 0.1] }),
            React.createElement("meshStandardMaterial", { color: 'green', opacity: 0.6, transparent: true }))));
};
